import React from 'react';
import RTL from './RTL';
import { MuiThemeProvider } from '@material-ui/core';
import { getTheme } from './Theme';
import PropTypes from 'prop-types';
import { useTranslation } from '../i18n/LanguageProvider';

const RtlWrapper = (props) => {
  const { direction } = useTranslation();

  return (
    <RTL>
      <MuiThemeProvider theme={getTheme(direction)}>
        {props.children}
      </MuiThemeProvider>
    </RTL>
  );
};

RtlWrapper.propTypes = {
  children: PropTypes.node
};

export default RtlWrapper;
